import { Navigate } from 'react-router-dom'

import { AvailableModules } from 'generated/featureDefinitions'

import i18n from 'modules/core/lib/i18n'

import { useWorkflowSurveysContext } from 'modules/surveys/hooks/useWorkflowSurveysContext'
import { hasSurveysModule } from 'modules/engagement/lib/hasSurveysModule'
import { useMarketplaceModulesPath } from 'modules/marketplace_modules/hooks/useMarketplaceModulesPath'
import { ValidReasons } from 'modules/upsell/hooks/useCreateUpsellRequest'
import { UpsellingKit } from 'modules/upselling_kit/components'
import coursesBackground from 'modules/upselling_kit/lib/assets/blankSlate/locked-courses-bg.svg'

const UpsellPage = () => {
  const { getListPath } = useMarketplaceModulesPath()

  const { moduleAvailabilities, upsellFlowEnabled } = useWorkflowSurveysContext()

  if (!hasSurveysModule(moduleAvailabilities) && !upsellFlowEnabled) {
    return <Navigate to={getListPath()} />
  }

  return (
    <UpsellingKit.EmptyState
      moduleRequested={AvailableModules.surveys}
      requestSource="Engagement main tabs"
      requestReason={ValidReasons.MissingAddon}
      background={coursesBackground}
      title={i18n.t('surveys.upsell.title')}
      description={i18n.t('surveys.upsell.description')}
    />
  )
}

export default UpsellPage
